// extracted by mini-css-extract-plugin
export default {"wrapper":"ListComponent_wrapper__zCC1a"};